import { useEffect, useState } from "react";
import InputField from "../../../InputField/InputField";
import Modal from "react-modal";
import close from "../../../../assets/close.png";
import useToggle from "../../../../hooks/useToggle";
import API from "../../../../libs/API";
import { useSelector } from "react-redux";
import { store } from "../../../../state/store";
import { setMessage } from "../../../../state/action-creators";

const UpdateAdminPhoneNumber = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const [showModal, toggleShowModal] = useToggle();
  const [isSaving, setIsSaving] = useState(false);
  const { user } = useSelector((state) => state.user);

  const handleChange = (e) => {
    setPhoneNumber((prev) => {
      if (e.target.value.length > 9 || /[a-zA-Z]/.test(e.target.value)) {
        return prev;
      }
      return e.target.value;
    });
  };

  const updatePhoneNumber = () => {
    setIsSaving(true);
    API.put(
      user,
      "/admin/phone",
      { phone: phoneNumber },
      () => {
        setIsSaving(false);
        toggleShowModal();
        store.dispatch(setMessage("ნომერი წარმატებით განახლდა"));
      },
      (err) => {
        store.dispatch(
          setMessage(err?.response?.data?.phone?.ge ?? "დაფიქსირდა შეცდომა")
        );
        setIsSaving(false);
      }
    );
  };

  const getPhoneNumber = () => {
    API.get(
      user,
      "/admin/phone",
      null,
      (res) => setPhoneNumber(res.phone),
      (err) => console.log(err)
    );
  };

  useEffect(() => {
    getPhoneNumber();
  }, [showModal]);

  return (
    <div className="update-admin-phone-number">
      <Modal
        isOpen={showModal}
        overlayClassName={"modal-overlay"}
        ariaHideApp={false}
        className={"modal-content"}
        shouldCloseOnOverlayClick={false}
        onRequestClose={toggleShowModal}
      >
        <div className="phone-change-modal">
          <img
            src={close}
            alt="close"
            className="close-icon"
            width={15}
            onClick={toggleShowModal}
          />
          <h1>გაანახლე ადმინისტრატორის ნომერი</h1>
          <label>ნომერი</label>
          <InputField
            type={"text"}
            value={phoneNumber}
            onChange={handleChange}
            placeholder={"+995"}
            disableLabel
          />
          <div className="phone-change-buttons">
            <button className="phone-change-cancel" onClick={toggleShowModal}>
              გაუქმება
            </button>
            <button className="phone-change-save" onClick={updatePhoneNumber}>
              {isSaving ? <div className="loader-black"></div> : "შენახვა"}
            </button>
          </div>
        </div>
      </Modal>
      <button onClick={toggleShowModal}>ადმინისტრატორის ნომრის შეცვლა</button>
    </div>
  );
};

export default UpdateAdminPhoneNumber;
